<template>
  <el-dialog
    :title="model.id > 0 ? '编辑流程' : '新建流程'"
    :visible.sync="visible"
    width="450px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      size="small"
      label-width="120px"
    >
      <el-form-item label="流程名称" prop="name">
        <el-input v-model="model.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="流程分组" prop="group_name">
        <el-select v-model="model.group_name" class="long">
          <el-option label="保内" value="保内" key="1"></el-option>
          <el-option label="保外" value="保外" key="2"></el-option>
          <el-option label="其他" value="其他" key="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="小程序显示">
        <template slot="label"
          >小程序显示<CustomTip :t="6"></CustomTip
        ></template>
        <el-select v-model="model.is_show_in_mini" class="long">
          <el-option label="是" :value="1" key="1"></el-option>
          <el-option label="否" :value="2" key="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联填写项">
        <el-checkbox-group v-model="model.relative_fileds">
          <el-checkbox :label="1">接收地点（维修点 / STC接收点）</el-checkbox>
          <el-checkbox :label="2">Service Order / Notification</el-checkbox>
          <el-checkbox :label="3">业务机会编号</el-checkbox>
          <el-checkbox :label="4">是否上门提货</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="submitForm" size="small"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  createServiceQuestFlow,
  updateServiceQuestFlow,
} from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur',
          },
        ],
        group_name: [
          { required: true, message: '请选择分类', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await updateServiceQuestFlow(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await createServiceQuestFlow(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.el-checkbox {
  width: 100%;
}
</style>